var types_TokenTypes = /*#__PURE__*/ function(TokenTypes) {
    TokenTypes["id"] = "id";
    TokenTypes["access"] = "access";
    TokenTypes["refresh"] = "refresh";
    return TokenTypes;
}({});
var types_CognitoHostedUIIdentityProvider = /*#__PURE__*/ function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Apple"] = "Apple";
    return CognitoHostedUIIdentityProvider;
}({});
var types_Auth0IdentityProvider = /*#__PURE__*/ function(Auth0IdentityProvider) {
    Auth0IdentityProvider["Google"] = "GooglePUP";
    Auth0IdentityProvider["Facebook"] = "FacebookPUP";
    Auth0IdentityProvider["Apple"] = "ApplePUP";
    return Auth0IdentityProvider;
}({});
export { types_Auth0IdentityProvider as Auth0IdentityProvider, types_CognitoHostedUIIdentityProvider as CognitoHostedUIIdentityProvider, types_TokenTypes as TokenTypes };
